<template>
  <div class="number">
    <span class="current">
      {{ index + 1 }}
    </span>

    <span class="limit"> /{{ $store.getters.sections.length }} </span>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.number {
  font-family: $bold-font;
  margin: 0 20px 0 auto;

  display: flex;
  align-items: flex-end;

  @include media-down(md) {
    margin-right: 10px;
  }
}

.current {
  font-size: 33px;

  @include media-down(md) {
    font-size: 16px;
  }
}

.limit {
  color: $main-color;
  font-size: 24px;

  @include media-down(md) {
    font-size: 12px;
  }
}
</style>
